import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shuju-h",
  "use": "icon-shuju-h-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shuju-h\"><path fill=\"currentColor\" d=\"M249.6 96a38.4 38.4 0 0 1 38.208 34.464L288 134.4v755.2a38.4 38.4 0 0 1-34.464 38.208L249.6 928H134.4a38.4 38.4 0 0 1-38.208-34.464L96 889.6V134.4a38.4 38.4 0 0 1 34.464-38.208L134.4 96h115.2z m256 128a38.4 38.4 0 0 1 38.208 34.464L544 262.4v627.2a38.4 38.4 0 0 1-34.464 38.208L505.6 928h-115.2a38.4 38.4 0 0 1-38.208-34.464L352 889.6V262.4a38.4 38.4 0 0 1 34.464-38.208L390.4 224h115.2z m256 224a38.4 38.4 0 0 1 38.208 34.464L800 486.4v403.2a38.4 38.4 0 0 1-34.464 38.208L761.6 928h-115.2a38.4 38.4 0 0 1-38.208-34.464L608 889.6V486.4a38.4 38.4 0 0 1 34.464-38.208L646.4 448h115.2zM224 160H160v704h64V160z m256 128h-64v576h64V288z m256 224h-64v352h64V512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shuju-h.svg
// module id = EoxJ
// module chunks = 102